import { MapPin, Home, Flag, Globe } from "lucide-react";
import Reveal from "./Reveal";

const NODES = [
  { name: "Praha", tag: "Domovská základna", x: 44, y: 40, main: true },
  { name: "Brno", tag: "ČR", x: 60, y: 58 },
  { name: "Drážďany", tag: "Německo", x: 30, y: 20 },
  { name: "Mnichov", tag: "Německo", x: 20, y: 78 },
  { name: "Vídeň", tag: "Rakousko", x: 62, y: 82 },
  { name: "Bratislava", tag: "Slovensko", x: 72, y: 72 },
];

const AREAS = [
  {
    icon: Home,
    title: "Praha a okolí",
    text: "Naše domovská základna — novostavby, rekonstrukce, zateplení i komerční fit-outy. Tady nabízíme nejrychlejší termíny a dohled nad každým detailem.",
  },
  {
    icon: Flag,
    title: "Komerční fit-outy po celé ČR",
    text: "Obchody a gastro provozy stavíme hlavně mimo Prahu — po celé republice a vždy na den přesně k otevření.",
  },
  {
    icon: Globe,
    title: "Slovensko · Rakousko · Německo",
    text: "V zahraničí realizujeme rekonstrukce bytů i komerční fit-outy. Zkušenosti s evropskými standardy přinášíme domů.",
  },
];

export default function Coverage() {
  return (
    <section id="pusobnost" data-testid="coverage-section" className="py-24 lg:py-32 bg-coal/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <Reveal>
          <p className="text-xs font-mono tracking-[0.3em] uppercase text-gold/70 mb-4">
            Kde působíme
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-zinc-100 leading-tight max-w-3xl">
            Z Prahy <span className="gold-text">až za hranice</span>
          </h2>
          <p className="mt-5 max-w-2xl text-zinc-400 leading-relaxed">
            Soustředíme se převážně na Prahu a okolí, ale naše projekty najdete po celé
            České republice i na Slovensku, v Rakousku a Německu.
          </p>
        </Reveal>

        <div className="mt-14 grid lg:grid-cols-2 gap-10 items-stretch">
          <Reveal delay={0.08}>
            <div
              className="relative h-full min-h-[380px] sm:min-h-[440px] rounded-xl border border-white/5 bg-ink overflow-hidden"
              data-testid="coverage-map"
            >
              <div
                className="absolute inset-0 opacity-40"
                style={{
                  backgroundImage: "radial-gradient(rgba(212,175,55,0.18) 1px, transparent 1px)",
                  backgroundSize: "26px 26px",
                }}
              />
              {[90, 150, 215].map((size) => (
                <span
                  key={size}
                  className="absolute rounded-full border border-gold/15"
                  style={{
                    width: size * 2,
                    height: size * 2,
                    left: `calc(44% - ${size}px)`,
                    top: `calc(40% - ${size}px)`,
                  }}
                />
              ))}
              {NODES.map((n) => (
                <div
                  key={n.name}
                  className="absolute -translate-x-1/2 -translate-y-1/2 flex flex-col items-center"
                  style={{ left: `${n.x}%`, top: `${n.y}%` }}
                >
                  {n.main ? (
                    <span className="relative flex h-4 w-4">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold opacity-60" />
                      <span className="relative inline-flex rounded-full h-4 w-4 bg-gold border-2 border-ink" />
                    </span>
                  ) : (
                    <span className="inline-flex rounded-full h-2.5 w-2.5 bg-zinc-300 border border-ink" />
                  )}
                  <span
                    className={`mt-2 text-[11px] font-semibold whitespace-nowrap ${
                      n.main ? "text-gold" : "text-zinc-300"
                    }`}
                  >
                    {n.name}
                  </span>
                  <span className="text-[9px] font-mono uppercase tracking-widest text-zinc-500 whitespace-nowrap">
                    {n.tag}
                  </span>
                </div>
              ))}
              <p className="absolute bottom-3 right-4 text-[10px] text-zinc-600 italic">
                Ilustrativní mapa působnosti
              </p>
            </div>
          </Reveal>

          <div className="flex flex-col gap-5">
            {AREAS.map((a, i) => (
              <Reveal key={a.title} delay={0.1 + i * 0.07}>
                <div
                  className="group h-full bg-card2 border border-white/5 hover:border-gold/30 rounded-xl p-6 transition-colors duration-500 flex gap-5"
                  data-testid={`coverage-area-${i}`}
                >
                  <span className="shrink-0 w-11 h-11 rounded-lg bg-gold/10 border border-gold/25 flex items-center justify-center text-gold group-hover:bg-gold group-hover:text-black transition-colors duration-300">
                    <a.icon size={18} />
                  </span>
                  <div>
                    <h3 className="text-zinc-100 font-semibold flex items-center gap-2">
                      {a.title}
                      {i === 0 && <MapPin size={14} className="text-gold" />}
                    </h3>
                    <p className="text-sm text-zinc-400 leading-relaxed mt-2">{a.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
